import type { DigitsRoute } from "@digits-shared/components/Router/DigitsRoute"
import objectHelper from "@digits-shared/helpers/objectHelper"
import routes from "src/frontend/routes"
import type SessionLegalEntity from "src/frontend/session/LegalEntity"

export const calculatePathRoute = (currentRoute: DigitsRoute, forceHome: boolean) => {
  if (forceHome) {
    return routes.legalEntityHome
  }

  return currentRoute.nearestUnparameterizedRoute() || routes.legalEntityHome
}

interface WithLegalEntity {
  legalEntity: SessionLegalEntity
}

export function compareLegalEntityNames<T extends WithLegalEntity>(a: T, b: T) {
  return objectHelper.compareObjectNames(a.legalEntity, b.legalEntity)
}

export function sortByLegalEntityName<T extends WithLegalEntity>(clients: T[]) {
  return clients.toSorted(compareLegalEntityNames)
}

export function matchesLegalEntity(legalEntity: SessionLegalEntity, searchTermRegex: RegExp) {
  return legalEntity.name.match(searchTermRegex) || legalEntity.slug.match(searchTermRegex)
}
